import React from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';

import { Container } from '@ttstr/components';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <Row>
        <Col md="4">
          <h2 className="mb-3 h5">{t(`FOOTER.HEAD1`)}</h2>
          <ul className="list-unstyled">
            <li>
              <Link to="/imprint">{t(`IMPRINT.TITLE`)}</Link>
            </li>
            <li>
              <Link to="/privacy">{t(`PRIVACY.TITLE`)}</Link>
            </li>
            <li>
              <Link to="/terms">{t(`TERMS_AND_CONDITIONS.TITLE`)}</Link>
            </li>
            <li>
              <a href="https://tickettoaster.de/retouren">Informationen zu Versand und Rückgabe</a>
            </li>
            <li>
              <a href="https://support.tickettoaster.de/RMA">{'Bestellung widerrufen'}</a>
            </li>
          </ul>
        </Col>
        <Col md="4">
          <h2 className="mb-3 h5">{t(`FOOTER.HEAD2`)}</h2>
          <p>Bei Fragen zu deiner Bestellung wende dich bitte an den Kundenservice der tickettoaster GmbH unter:</p>
          <p className="font-weight-bolder">
            Tel.: +49 561 350 296 28 - 0<br />
            <a href="mailto:hallo@tickettoaster.de">hallo@tickettoaster.de</a>
          </p>
        </Col>
        <Col md="4" className="text-sm-right"></Col>
      </Row>
      <Row className="mt-5 d-flex align-items-center">
        <Col md="8" lg="6" className="align-items-end mt-4 text-left text-muted copyright">
          <p className="mb-0">
            &copy; 2024 <a href="www.felixlobrecht-tickets.de">FELIX LOBRECHT</a>
            <br />
            powered by <a href="https://www.tickettoaster.de">teamtoaster Direct-To-Fan Commerce</a>
          </p>
        </Col>
        <Col md="4" lg="6" className="d-flex align-items-end justify-content-between mt-4 copyright-logos">
          <a href="https://tickettoaster.de" target="_blank" rel="noreferrer noopener">
            <img
              src={require('@ttstr/assets/images/logo_teamtoaster_full_black.png')}
              alt="powered by teamtoaster"
              title="powered by teamtoaster"
              loading="lazy"
              className="img-fluid"
            />
          </a>
          <a href="https://www.12k.de" target="_blank" className="" rel="noreferrer noopener">
            <img
              src={require('./assets/images/12k_logo.png')}
              alt="powered by ZWOELFK"
              title="powered by ZWOELFK"
              loading="lazy"
              className="img-fluid"
            />
          </a>
          <a href="https://www.standup44.de" target="_blank" className="" rel="noreferrer noopener">
            <img
              src={require('./assets/images/su44.png')}
              alt="powered by stand up 44"
              title="powered by stand up 44"
              loading="lazy"
              className="img-fluid"
            />
          </a>
          <a href="https://www.felixlobrecht.de" target="_blank" className="" rel="noreferrer noopener">
            <img
              src={require('./assets/images/fl-neu.png')}
              alt="powered by FELIX LOBRECHT"
              title="powered by FELIX LOBRECHT"
              loading="lazy"
              className="img-fluid"
            />
          </a>
        </Col>
      </Row>
    </Container>
  );
};

export default React.memo(Footer);
